import { render, staticRenderFns } from "./proList.vue?vue&type=template&id=41f948c8&scoped=true&"
import script from "./proList.vue?vue&type=script&lang=js&"
export * from "./proList.vue?vue&type=script&lang=js&"
import style0 from "./proList.vue?vue&type=style&index=0&id=41f948c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f948c8",
  null
  
)

export default component.exports